// PhoneCanvas масштабирует макет через CSS `zoom`. dnd-kit считает сдвиг в
// НЕотмасштабированных CSS-px и кладёт его в transform ВНУТРИ zoom-контейнера,
// где 1px = scale реальных пикселей. Без деления на scale элемент уезжает
// быстрее курсора. Поэтому scale публикуется в контексте для dnd-модификатора.
import { createContext, useContext } from 'react'

export const PhoneScaleContext = createContext(1)

/** Текущий масштаб макета телефона (нужен dnd внутри канваса). */
export const usePhoneScale = (): number => useContext(PhoneScaleContext)
